import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

export default function AdminDepartments() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadDepartments = useCallback(() => {
    setLoading(true);
    api.get('/admin/departments')
      .then((res) => setDepartments(res.data))
      .catch(() => setError('Nuk arritëm të ngarkonim departamentet.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { loadDepartments(); }, [loadDepartments]);

  const handleDelete = async (id) => {
    if (!window.confirm('A jeni të sigurt që doni të fshini departamentin?')) return;
    try {
      await api.delete(`/admin/departments/${id}`);
      toast.success('Departamenti u fshi.');
      loadDepartments();
    } catch {
      toast.error('Gabim gjatë fshirjes.');
    }
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="page-title">Departamentet</h1>
          <p className="admin-page-sub">Lista e departamenteve në sistemin e administrimit</p>
        </div>
        <Link to="/admin/departamentet/i-ri" className="btn btn-primary">
          <Plus size={15}/> Departament i ri
        </Link>
      </div>

      <div className="card">
        {error && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
        {loading ? (
          <div className="spinner" />
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Emri</th>
                  <th>Slug</th>
                  <th>Statusi</th>
                  <th>Renditja</th>
                  <th>Veprimet</th>
                </tr>
              </thead>
              <tbody>
                {departments.map((dept) => (
                  <tr key={dept.id}>
                    <td>{dept.id}</td>
                    <td>{dept.name}</td>
                    <td>{dept.slug}</td>
                    <td>{dept.is_active ? 'Aktiv' : 'Jo aktiv'}</td>
                    <td>{dept.sort_order}</td>
                    <td>
                      <div className="action-btns">
                        <Link to={`/admin/departamentet/${dept.id}/ndrysho`} className="btn btn-secondary btn-sm">
                          <Edit size={13}/>
                        </Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(dept.id)}>
                          <Trash2 size={13}/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {departments.length === 0 && (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', color: 'var(--gray-400)', padding: '2rem' }}>
                      Nuk ka departamente.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
